import { makeAutoObservable, observable } from 'mobx';
import { Assets } from 'pixi.js';

export class ParticlesStore {
  configs = observable.map();
  isLoading = false;
  options;

  constructor(options) {
    this.options = options;
    makeAutoObservable(this, {
      isLoading: observable,
    });
  }

  async loadAssets() {
    const isStage = this.options.isStage;
    if (this.isLoading || this.configs.size > 0) {
      // console.log('[ParticlesStore] ⏭️ Пропуск: ассеты уже загружаются или уже загружены.');
      return;
    }

// console.log('[ParticlesStore] ⏳ Старт загрузки ассетов...');
this.isLoading = true;

const { systemConfig, texturesConfig, libType, upgradeConfigFn } = this.options;

try {
  const textureManifest = new Set();
  for (const pathArray of Object.values(texturesConfig)) {
    for (const path of pathArray) {
      textureManifest.add(path);
    }
  }

  const texturePaths = Array.from(textureManifest);

  // console.log(
  //   `[ParticlesStore] 📦 Подготовка: найдено ${texturePaths.length} уникальных путей к текстурам.`,
  //   texturePaths
  // );

  // Ждем загрузки всех текстур
  const loadedTextures = await Assets.load(texturePaths);

  // console.log(`[ParticlesStore] ✅ Текстуры скачаны в кеш:`, Object.keys(loadedTextures));

  // console.log(
  //   `[ParticlesStore] ⚙️ Начинаем парсинг конфигов для ${
  //     Object.keys(systemConfig).length
  //   } эффектов...`
  // );

  for (const configKey of Object.keys(systemConfig)) {
    const configEntry = systemConfig[configKey];
    if (!configEntry) {
      // console.warn(
      //   `[ParticlesStore] ⚠️ Внимание: Пустой configEntry для ключа "${configKey}".`
      // );
      continue;
    }

    // Проверяем наличие JSON в кеше PixiJS
    const asset = Assets.get(configEntry.name);
    if (!asset) {
      // console.error(
      //   `[ParticlesStore] ❌ ОШИБКА: "Сырой" JSON-конфиг "${configEntry.name}" не найден в кеше Assets! (Возможно, он не был добавлен в основной манифест загрузки игры).`
      // );
      continue;
    }

    const texturePathsForThisConfig = texturesConfig[configKey];
    if (!texturePathsForThisConfig) {
      // console.error(
      //   `[ParticlesStore] ❌ ОШИБКА: Не найдены пути текстур для эффекта "${configKey}" в texturesConfig.`
      // );
      continue;
    }

    const textures = texturePathsForThisConfig
      .map((path) => loadedTextures[path])
      .filter(Boolean);

    if (textures.length === 0) {
      // console.warn(
      //   `[ParticlesStore] ⚠️ Внимание: Массив текстур для "${configKey}" оказался пуст после фильтрации!`
      // );
    } else {
      // console.log(
      //   `[ParticlesStore] 🖼️ Текстуры для "${configKey}" собраны (${textures.length} шт.).`
      // );
    }

    let cleanedAsset = asset;
    if (Array.isArray(asset.art)) {
      cleanedAsset = {
        ...asset,
        art: asset.art.filter(Boolean),
      };
    }

    // В зависимости от библиотеки собираем нужный формат
    let finalConfig;

    if (libType === 'default' && upgradeConfigFn) {
      finalConfig = upgradeConfigFn(cleanedAsset, textures);
    } else if (libType === 'custom') {
      // 💡 ИСПРАВЛЕНИЕ: Передаем массив путей (строк), а не объекты PIXI.Texture.
      // Это защитит нас от того, что MobX испортит объекты своими Proxy.
      finalConfig = { config: cleanedAsset, textures: texturePathsForThisConfig };
    } else {
      if (isStage)
        /*console.error(`[ParticlesStore] Неизвестный libType: ${libType}`);*/
        finalConfig = cleanedAsset;
    }

    this.configs.set(configEntry.name, finalConfig);

    // console.log(`[ParticlesStore] ✅ Конфиг "${configEntry.name}" готов и сохранен в Store.`);
  }

  // console.log(
  //   `[ParticlesStore] 🎯 ЗАВЕРШЕНО: Все доступные ассеты обработаны. Итого в Store: ${this.configs.size} шт.`
  // );
} catch (error) {
  // console.error(
  //   '[ParticlesStore] ❌ КРИТИЧЕСКАЯ ОШИБКА при загрузке ассетов партиклов:',
  //   error
  // );
} finally {
  this.isLoading = false;
}
  }
}